import React, { useEffect, useState } from "react";
import { HistoricCases } from "./HistoricCases";
import { TabMenu } from "../common/TabMenu";
import { IdentifyLead } from "./contract/IdentifyLead";
import { Exceptions } from "./contract/Exceptions";
import { CaseWrapper } from "./case/CaseWrapper";
import { Processes } from "./Processes";
import { useDispatch, useSelector } from "react-redux";
import { selectContract } from "../../redux/contract/selectors";
import { PauData } from "./contract/Pau";
import { Workshop } from "./contract/Workshop";
import { FactoryCases } from "./FactoryCases";
import { factoryActive } from "../../Constantes/factoryActive";
import { CaseStateSummary } from "./CaseStateSummary";
import { ContractSearch } from "./ContractSearch";
import { HistoricCaseDetail } from "./HistoricCaseDetail";
import { Divider } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { ChatRAG } from "./contract/ChatRAG";
import { AgentAssist } from "./chatRAG/Chat";
import { ORACLE_Customer } from "./contract/ORACLE_Customer";
import { ORACLE_Customer_Tickets } from "./contract/ORACLE_Customer_Tickets";
import iconoAdd from '../../images/iconoAdd.svg';
import iconEditarLead from '../../images/iconEditarLead.svg';
import { openModal } from "../../redux/modal/modalSlice";
import { createCustomer, editCustomer } from "../../redux/customers/thunks";
import { errorHandler } from "../../commonFunctions/errorHandler";
import { getContract } from "../../redux/contract/thunks";
import CustomerDialog from "./contract/CustomerDialog";
import ContractDialog from "./contract/ContractDialog";
import VehicleDialog from "./contract/VehicleDialog";

function PanelGrid(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const contract = useSelector(selectContract);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      //behavior: 'smooth'
    });
  };
  useEffect(() => {
    handleScrollToTop();
  }, []);

  const [showCustomerDialog, setShowCustomerDialog] = useState(false);
  function toogleCustomerDialog() {
    setShowCustomerDialog(!showCustomerDialog);
  }
  const [showContractDialog, setShowContractDialog] = useState(false);
  function toogleContractDialog() {
    setShowContractDialog(!showContractDialog);
  }
  const [showVehicleDialog, setShowVehicleDialog] = useState(false);
  function toogleVehicleDialog() {
    setShowVehicleDialog(!showVehicleDialog);
  }

  return (
    <>
    
      {/* <CustomerDialog
        editMode={contract?.customerId != null}
        title={contract?.customerId == null ? 'Cadastrar Cliente' : 'Editar Cliente'}
        operation={customerFormOperation}
        dialogSize={{ height: '100%' }}
        open={showCustomerDialog}
        onClose={closeCustomerDialog}
        handleOnClick={handleCustomerSubmit}
        dataForm={customerDataForm}
        onChange={onChangeCustomerData}
      ></CustomerDialog> */}

      <CustomerDialog
        contract={contract}
        dialogSize={{ height: '100%' }}
        open={showCustomerDialog}
        onClose={toogleCustomerDialog}
      ></CustomerDialog>

      
      <ContractDialog
        contract={contract}
        dialogSize={{ height: '100%' }}
        open={showContractDialog}
        onClose={toogleContractDialog}
      />

      <VehicleDialog
        contract={contract}
        dialogSize={{ height: '100%' }}
        open={showVehicleDialog}
        onClose={toogleVehicleDialog}
      />
    
      <div className="panel-main">
        <div className="panel-grid">
          <div className="panel-contract-cell">
            <ContractSearch />
            <div className="panel-lead-data-wrapper">
              <TabMenu
                variant={"fullWidth"}
                key="id-lead"
                labels={[
                  { label: t("Customer"), showIcon: true, iconSVG: contract?.customerId != null ? iconEditarLead : iconoAdd, iconOnClick:toogleCustomerDialog, iconAlt: contract?.customerId != null ? 'Editar cliente' : 'Cadastrar cliente' },
                  { label: t("Contract"), showIcon: contract?.customerId != null, iconSVG: contract?.customerId != null ? iconEditarLead : iconoAdd, iconOnClick:toogleContractDialog, iconAlt: contract?.customerId != null ? 'Editar contrato' : 'Cadastrar contrato' },
                  { label: t("Vehicle"), showIcon: contract?.customerId != null, iconSVG: (contract?.modelId != null && contract?.modelId > 0 ) ? iconEditarLead : iconoAdd, iconOnClick:toogleVehicleDialog, iconAlt: (contract?.modelId != null && contract?.modelId > 0 ) ? 'Editar veículo' : 'Cadastrar veículo' },
                  // { label: t("Customer"), showIcon: true },
                  // { label: "Tickets", showIcon: true },
                  
                  //{ label: t("AgentAssist") },

                  // {label: "Vehículo"},
                  // {label:"PAU"},
                  // {label:<span className={contract?.exceptions?.length > 0 ? "exception-warning" : undefined}> Exceções </span>},
                  // {label:"Talleres"}
                ]}
              >
                <IdentifyLead mode={"customer"} />
                <IdentifyLead mode={"contract"} />
                <IdentifyLead mode={"vehicle"}/>
                {/* <ChatRAG /> */}

                {/* <ORACLE_Customer />
                <ORACLE_Customer_Tickets /> */}
                {/* <AgentAssist /> */}

                {/* <IdentifyLead mode={"vehicle"}/>
                      <PauData/>
                      <Exceptions />
                      <Workshop/> */}
                {/* <Processes treeDisplay={"horizontal"} treeIframeId={"treeIframeVertical"}/> */}
              </TabMenu>
            </div>
          </div>
          <div className="panel-case-cell">
            <CaseWrapper handleNewCase={props.handleNewCase} />
          </div>
        </div>
        <CaseStateSummary />
        <div className="panel-history-grid">
          <TabMenu
            key="id-historic"
            labels={[
              { label: t("CustomerHistory") },
              //{ label: t("Process") },
              // { label: "Casos Fábrica", disabled: !factoryActive },
            ]}
            height={"100%"}
          >
            <HistoricCases />
            <Processes
              treeDisplay={"horizontal"}
              treeIframeId={"treeIframeHorizontal"}
            />
            {/* <FactoryCases disabled/> */}
          </TabMenu>
          <div style={{ margin: "3rem 0" }}>
            <Divider orientation="horizontal" />
          </div>
          <HistoricCaseDetail />
        </div>
      </div>
    </>
  );
}

export { PanelGrid };
